
import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DriverStatisticsQuery } from '../types';

/**
 * typeguard for DriverStatisticsQuery
 * @param DriverStatisticsQuery object passed to transformer
 */
export const isValidDriverStatistics = (obj: DriverStatisticsQuery): boolean => Boolean(obj?.data?.getDriverStatsWidget && !isEmptyObject(obj.data.getDriverStatsWidget));
